import { render, staticRenderFns } from "./plays_odds.vue?vue&type=template&id=1869d6ff&"
import script from "./plays_odds.vue?vue&type=script&lang=js&"
export * from "./plays_odds.vue?vue&type=script&lang=js&"
import style0 from "./plays_odds.vue?vue&type=style&index=0&id=1869d6ff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports